import * as Cesium from 'cesium';

interface PropertyRow {
  label: string;
  value: string;
}

const PROPERTY_LABELS: Record<string, string> = {
  'gml:id': '識別子',
  gml_id: '識別子',
  id: '識別子',
  name: '名称',
  address: '住所',
  class: '分類',
  function: '用途',
  usage: '用途',
  measuredHeight: '高さ',
  measuredheight: '高さ',
  height: '高さ',
  storeysAboveGround: '地上階数',
  yearOfConstruction: '建築年',
  routeName: '路線名',
  width: '幅員',
  status: '整備状況',
};

function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

export function readFeatureProperties(
  feature: unknown,
): PropertyRow[] {
  if (!feature || typeof feature !== 'object') return [];
  const candidate = feature as {
    getPropertyIds?: () => string[];
    getProperty?: (name: string) => unknown;
  };
  if (!candidate.getPropertyIds || !candidate.getProperty) return [];

  return candidate
    .getPropertyIds()
    .map((key) => ({
      label: PROPERTY_LABELS[key] ?? key,
      value: displayValue(candidate.getProperty?.(key)),
    }))
    .filter((row) => row.value !== '—')
    .slice(0, 12);
}

export class InfoPanel {
  private readonly root = document.getElementById('infoPanel');
  private readonly title = document.getElementById('infoTitle');
  private readonly source = document.getElementById('infoSource');
  private readonly body = document.getElementById('infoBody');
  private readonly closeButton = document.getElementById(
    'infoClose',
  ) as HTMLButtonElement | null;

  constructor() {
    this.closeButton?.addEventListener('click', () => this.hide());
  }

  show(
    title: string,
    source: string,
    properties: PropertyRow[],
  ): void {
    if (!this.root || !this.title || !this.source || !this.body) return;
    this.title.textContent = title;
    this.source.textContent = source;
    this.body.replaceChildren();

    if (properties.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'info-empty';
      empty.textContent = '取得できる属性情報はありません';
      this.body.append(empty);
    } else {
      for (const row of properties) {
        const item = document.createElement('div');
        item.className = 'info-row';
        const label = document.createElement('dt');
        label.textContent = row.label;
        const value = document.createElement('dd');
        value.textContent = row.value;
        item.append(label, value);
        this.body.append(item);
      }
    }
    this.root.hidden = false;
    this.root.classList.add('is-visible');
  }

  hide(): void {
    this.root?.classList.remove('is-visible');
    if (this.root) this.root.hidden = true;
  }
}

export function selectedTileset(
  picked: unknown,
): Cesium.Cesium3DTileset | undefined {
  if (!picked || typeof picked !== 'object') return undefined;
  const candidate = picked as {
    tileset?: Cesium.Cesium3DTileset;
    primitive?: { tileset?: Cesium.Cesium3DTileset };
  };
  return candidate.tileset ?? candidate.primitive?.tileset;
}
